<template>
  <div id="app">
    <div class="closs" v-if="show == '1'">
      <p></p>
      <p></p>
      <p>系统已关闭。</p>
      <img src="./assets/tips.png" alt="" />
    </div>
    <router-view v-else />
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import "./common/ban"; //禁止控制台
// import "./common/th"; //全局替换
import { getsarends } from "@/api/api";
import ecSite from "@/common/site";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      show: "0", //0 系统开放 1-系统关闭
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let s = [];
    s = ecSite.decryptByDES("");
    console.log(s);
    this.getsarend();
  },
  //方法集合
  methods: {
    //获取配置开放信息
    async getsarend() {
      this.$tip(true, "正在加载中。。。");
      const data = await getsarends();
      console.log(data);
      // this.$loading().close();
      this.$tip(false);
      if (data.code == 200) {
        if (data.data == 0) {
          this.show = "1";
        }
      } else {
        if (data.msg != "token过期，请重新登录！") {
          this.$message.error(data.msg);
        }
      }
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.closs {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.2rem;
  img {
    width: 28rem;
    height: 16rem;
  }
}
</style>
<style lang="less">
body {
  margin: 0px;
  padding: 0px;
  /*overflow: hidden;*/
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  background: #f1f1f1;
  font-size: 1rem;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
